"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOlapicDetails = void 0;
var _react = require("react");
var _styles = require("../../containers/Widget/styles");
var _utils = require("../../utils");
var _olapicDataContext = require("./olapicDataContext");
const useOlapicDetails = () => {
  const {
    setActiveMedia,
    isOpenDetails
  } = (0, _olapicDataContext.useOlapicData)();
  const onOpenDetails = (0, _react.useCallback)((activeItem, eventMeta) => {
    (0, _utils.createUserActionEvent)(eventMeta);
    document.body.classList.add(_styles.classes.noScroll);
    setActiveMedia(activeItem);
  }, [setActiveMedia]);
  const onCloseDetails = (0, _react.useCallback)(() => {
    document.body.classList.remove(_styles.classes.noScroll);
    setActiveMedia('');
  }, [setActiveMedia]);
  return {
    isOpenDetails,
    onOpenDetails,
    onCloseDetails
  };
};
exports.useOlapicDetails = useOlapicDetails;
